__turbopack_context__.v({
  "card": "IndustryCard-module-scss-module__d3wEqa__card",
  "iconContainer": "IndustryCard-module-scss-module__d3wEqa__iconContainer",
});
